import { useDisclosure } from '@mantine/hooks';
import { IconShirt } from '@tabler/icons-react';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStyle, getStyleAssets } from 'services/styleService';
import ResolverImage from '../resolverImage/ResolverImage';
import { logger } from 'utils/logger';
import { getStatusColor, getStyleStatusColor } from 'utils/helper';
import { StyleSwatch } from '..';

const { Popover, Text, Group, Button, createStyles, Box, Badge, Skeleton } = require('@mantine/core');

const useStyles = createStyles((theme) => ({
    card: {
        //   margin:-theme.spacing.md,
        padding: 0,
        position: 'relative',
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
    },

    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        //   letterSpacing: -0.25),
        textTransform: 'uppercase',
    },

    section: {
        paddingTop: theme.spacing.md,
        paddingBottom: theme.spacing.md,
        borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
        margin: 0,
    },

    icon: {
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
}));

const StylePopover = (props) => {
    const [opened, { close, open }] = useDisclosure(false);
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const { classes } = useStyles();
    const popRef = useRef();
    const doClose = useRef(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (opened) {
            
            async function fetchSample() {
                setLoading(true);
                try {
                    var val = await getStyle(props.data.stylePart);
                    if(!val){
                        setData(null);
                        logger.log('no data');
                        return;
                    }
                    logger.log(val, " DATA HERE");
                    const assetData = await getStyleAssets(props.data.stylePart);
                    var assets = [];
                    var preview;
                    if(assetData && assetData.length){
                        assets = [...assetData];
                        preview = assetData[0].thumb;
                        if(!val.preview){
                            val.preview = preview;
                        }
                    }
                    setData({ ...props.data, ...val, assets:assets });
                } catch(e) {
                    logger.error('fetchSample error', e);
                    setData(null);
                } finally {
                    setLoading(false);
                }
            }
            // fetch the sample
            if (!data || (data && data.styleSort !== props.data.styleSort && opened)) fetchSample();
        }
    }, [opened]);

    const mouseHandler = (e) => {
        setTimeout(() => {
            if (doClose.current) {
                close();
                doClose.current = true;
            }
        }, 200);
    };

    const showDetails = () => {
        navigate(`/warehouse/styles/${props.data.stylePart}`);
        props.onShowDetails?.();
    };

    logger.log(data, ' DATA HERE')
    return (
        <Popover withinPortal={true} width={300} position='bottom-end' withArrow shadow='md' opened={opened}>
            <Popover.Target>
                <div ref={popRef} onMouseEnter={open} onMouseLeave={(e) => mouseHandler(e)}>
                    {props.children}
                </div>
            </Popover.Target>

            <Popover.Dropdown sx={{ pointerEvents: 'initial' }}>
                {loading ? (
                    <Box>
                        <Skeleton height={180} mb="md" />
                        <Skeleton height={12} mb="xs" />
                        <Skeleton height={12} width="60%" />
                    </Box>
                ) : data ? (
                    <Box
                        className={classes.card}
                        style={{ padding: 0 }}
                        onMouseLeave={() => {
                            close();
                            doClose.current = true;
                        }}
                        onMouseEnter={() => {
                            open();
                            doClose.current = false;
                        }}>
                        <Box className={classes.imageSection}>
                            {/* <Image src="https://i.imgur.com/ZL52Q2D.png" /> */}
                            {/* <IconShirt size={72} stroke={1} /> */}
                            <ResolverImage eager width={120} height={180} src={data.preview} />
                        </Box>

                        <Group position='apart' mt='md'>
                            <div>
                                <Text fw={500}>{data?.name}</Text>
                                <Text color='dimmed' size={'sm'} lineClamp={2}>
                                    {data?.id}
                                </Text>
                            </div>
                            <Badge color={getStyleStatusColor(data?.status)} variant="light" >{data?.status}</Badge>
                        </Group>

                        <Box className={classes.section} mt='md'>
                            <Group>
                                <div>
                                    <Text size='sm' c='dimmed' className={classes.label}>
                                        ASSETS
                                    </Text>

                                    <Group spacing={8} mb={-8}>
                                    {/* {data?.name} */}
                                    {data?.assets?.map((val, idx) => {

                                        return (
                                            <React.Fragment key={idx}>
                                            <ResolverImage eager src={val.thumb} height={30} width={30} />
                                            </React.Fragment>
                                        )
                                    })}
                                    </Group>
                                </div>
                            </Group>
                        </Box>

                        <Box className={classes.section} mt='md'>
                            <Group grow>
                                <div>
                                    <Text size='sm' c='dimmed' className={classes.label}>
                                        Swatch
                                    </Text>

                                    <StyleSwatch showTooltip={false} autoWidth={false} doFetch={true} styleId={props.data.stylePart} />
                                </div>
                            </Group>
                        </Box>

                        {/* <Box className={classes.section}>
                            <Group position='apart'>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Size Count
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.sizeCount}
                                    </Text>
                                </div>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Style Count
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.styleCount}
                                    </Text>
                                </div>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Colour Count
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.colourCount}
                                    </Text>
                                </div>
                            </Group>
                        </Box> */}
                        <Box className={classes.section}>
                            <Group spacing={30}>
                                <Button style={{ flex: 1 }} onClick={showDetails}>
                                    View Details
                                </Button>
                            </Group>
                        </Box>
                    </Box>
                ) : (
                    <Box>
                        <Text size={'sm'} color='dimmed'>
                            There is no style information available
                        </Text>
                    </Box>
                )}
            </Popover.Dropdown>
        </Popover>
    );
};

export default StylePopover;
